import { AdminCountyData } from '@models/interfaces';

export const COUNTY_DEFAULT_VALUE: AdminCountyData = {
  id: '',
  name: '',
};
